// extracted by mini-css-extract-plugin
module.exports = {"content":"PaymentMethodSelector_content__2MV-3","box":"PaymentMethodSelector_box__moQmn"};